import LuxeStay from "../Images/LuxeStay.png";
import Goway from "../Images/Goway.png";
import FoodieGo from "../Images/FoodieGo.png";
import BiteBliss from "../Images/BiteBliss.png";
import Movie from "../Images/Movie.jpg";
import PinkPearl from "../Images/PinkPearl.png";
import Insurance from "../Images/Insurance.png";
import QuickAi from "../Images/QuickAi.png";
import BSN from "../Images/BSN.jpeg";
import CSI from "../Images/cloudsolutionlk_logo.jpeg"

export const Bio = {
    name: "Thuvaraki",
    roles: ["Quality Engineer"],
    description:
        "A highly motivated individual with hands-on experience in manual testing, mobile automation, API testing, AI application testing, and performance testing for Hospital Information System. Experienced in designing and executing functional, regression, integration, and exploratory test scenarios, while developing Android automation solutions using Java, Appium, Selenium WebDriver, and TestNG. Familiar with Agile methodologies, defect management, API validation, and quality engineering practices with a focus on delivering reliable software.",
    github: "https://github.com/Thuvaraki",
    resume:
        "https://drive.google.com/file/d/1_94tXXnkI_x2TXJ_xaoaNyf93-Vyo10S/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/thuvaraki/",
};

export const education = [
    {
        id: 0,
        img: "data:image/jpeg;base64,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",
        school: "University of Kelaniya",
        date: "2022 - 2026",
        grade: "GPA: 3.80 / 4.00",
        degree: "BSc (Hons) in Software Engineering",
    },
    {
        id: 1,
        img: "https://upload.wikimedia.org/wikipedia/en/3/3f/Chavakachcheri_Hindu_College_logo.jpg",
        school: "J/Chavakachcheri Hindu College",
        date: "2020",
        grade: "Combined Mathematics (A), Physics (B), Chemistry (B)",
        degree: "GCE Advanced Level",
    },
    {
        id: 2,
        img: "https://upload.wikimedia.org/wikipedia/en/3/3f/Chavakachcheri_Hindu_College_logo.jpg",
        school: "J/Chavakachcheri Hindu College",
        date: "2016",
        grade: "9 As' including English Literature, ICT, and Commerce",
        degree: "GCE Ordinary Level",
    },
];

export const skills = [
    {
        title: "Automation Testing",
        skills: [
            {
                name: "Selenium WebDriver",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/d/d5/Selenium_Logo.png",
            },
            {
                name: "Appium",
                image:
                    "https://appium.io/docs/en/latest/assets/images/appium-logo-horiz.png",
            },
            {
                name: "Rest Assured",
                image:
                    "https://raw.githubusercontent.com/rest-assured/rest-assured/master/rest-assured-logo.png",
            },
            {
                name: "Playwright",
                image:
                    "https://playwright.dev/img/playwright-logo.svg",
            },
            {
                name: "TestNG",
                image:
                    "https://testng.org/doc/images/testng-logo.png",
            },
            {
                name: "JUnit",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/junit/junit-original.svg",
            },
            {
                name: "Page Object Model",
                image:
                    "https://www.selenium.dev/images/selenium_logo_square_green.png",
            },
        ],
    },
    {
        title: "Performance Testing",
        skills: [
            {
                name: "Apache JMeter",
                image:
                    "https://jmeter.apache.org/images/jmeter.png",
            },
            {
                name: "K6",
                image:
                    "https://k6.io/docs/images/k6-logo.svg",
            },
            {
                name: "Locust",
                image:
                    "https://raw.githubusercontent.com/locustio/locust/master/docs/images/locust-logo.svg",
            },
        ],
    },
    {
        title: "Tools",
        skills: [
            {
                name: "Postman",
                image:
                    "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
            },
            {
                name: "Insomnia",
                image:
                    "https://raw.githubusercontent.com/Kong/insomnia/develop/packages/insomnia/src/ui/assets/images/logo.svg",
            },
            {
                name: "Jira",
                image:
                    "https://cdn.worldvectorlogo.com/logos/jira-1.svg",
            },
            {
                name: "TestRail",
                image:
                    "https://www.gurock.com/wp-content/uploads/2021/05/TestRail-logo.svg",
            },
            {
                name: "Android Studio",
                image:
                    "https://developer.android.com/static/studio/images/studio-icon.svg",
            },
            {
                name: "IntelliJ IDEA",
                image:
                    "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/intellij/intellij-original.svg",
            },
            {
                name: "VS Code",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png",
            },
        ],
    },
    {
        title: "DevOps & CI/CD",
        skills: [
            {
                name: "Git",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
            },
            {
                name: "GitHub",
                image:
                    "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
            },
            {
                name: "Jenkins",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/jenkins/jenkins-original.svg",
            },
            {
                name: "Docker",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
            },
            {
                name: "AWS",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
            },
        ],
    },
    {
        title: "Frontend",
        skills: [
            {
                name: "React Js",
                image:
                    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
            },
            {
                name: "Next Js",
                image:
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
            },
            {
                name: "HTML",
                image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
            },
            {
                name: "CSS",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
            },
            {
                name: "JavaScript",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
            },
            {
                name: "Bootstrap",
                image:
                    "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
            },
            {
                name: "TailwindCSS",
                image:
                    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVgHWDyjwN9qZsPChFzc5PRfOOOqbfgXqR3w&s",
            },
            {
                name: "Angular",
                image:
                    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcROSVsyTE3Rq2DeKnZ9DvrUCTjEv6k0NTDNvw&s",
            },
            {
                name: "TypeScript",
                image:
                    "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Typescript.svg/1200px-Typescript.svg.png",
            },
        ],
    },
    {
        title: "Backend",
        skills: [
            {
                name: "Java",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
            },
            {
                name: "SpringBoot",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/spring/spring-original.svg",
            },
            {
                name: "Node Js",
                image: "https://nodejs.org/static/images/logo.svg",
            },
            {
                name: "Express Js",
                image:
                    "data:image/png;base64,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",
            },
            {
                name: "SQL",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg",
            },
            {
                name: "MySQL",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
            },
            {
                name: "MongoDB",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
            },
            {
                name: "postgresql",
                image:
                    "https://www.arbin.com/wp-content/uploads/2024/09/ARBIN-Introduction-Postgre-SQL-i2.png",
            },
            {
                name: "Firebase",
                image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
            },
        ],
    },
    {
        title: "Machine Learning",
        skills: [
            {
                name: "Python",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
            },
            {
                name: "Numpy",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/numpy/numpy-original.svg",
            },
            {
                name: "Pandas",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/pandas/pandas-original.svg",
            },
            {
                name: "Matplotlib",
                image:
                    "https://matplotlib.org/_static/images/logo2.svg",
            },
            {
                name: "Seaborn",
                image:
                    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
            },
            {
                name: "Jupyter",
                image:
                    "https://raw.githubusercontent.com/devicons/devicon/master/icons/jupyter/jupyter-original.svg",
            },
        ],
    },
    {
        title: "Methodologies",
        skills: [
            {
                name: "Agile Scrum",
                image:
                    "https://cdn.worldvectorlogo.com/logos/scrum.svg",
            },
            {
                name: "SDLC",
                image:
                    "https://cdn-icons-png.flaticon.com/512/1055/1055646.png",
            },
            {
                name: "STLC",
                image:
                    "https://cdn-icons-png.flaticon.com/512/2991/2991148.png",
            },
        ],
    },
];

export const experiences = [
    {
        id: 1,
        img: CSI,
        role: "QA Engineer Intern",
        company: "Cloud Solutions International",
        date: "Feb 2026 - Aug 2026",
        desc: "Performed manual and API testing for enterprise healthcare platforms, covering functional, regression, integration, and exploratory testing. Validated AI-powered healthcare applications, executed REST API and performance testing using Postman and JMeter, automated Android workflows with Java, Selenium, Appium, and TestNG, and managed defect tracking in Jira within Agile Scrum teams.",
        skills: ["Java", "Appium", "Selenium WebDriver", "TestNG", "API testing", "AI application testing", "performance testing"],
    },
    {
        id: 0,
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqGwqT9eJ7kKwNdI98H0kbovQ1KS7cyIZPFw&s",
        role: "Software Engineer Intern",
        company: "Kapruka Holdings PLC.",
        date: "Dec 2024 - June 2025",
        desc: "Contributed to the maintenance and enhancement of a legacy e-commerce application. Developed and optimized full-stack features, including frontend interfaces, backend logic, and database operations. Resolved multiple bugs to improve application stability and performance. Actively participated in team meetings to discuss project progress, clarify requirements, and suggest improvements.",
        skills: ["Java", "JavaScript", "HTML", "SQL", "CSS", "BootStrap"],
    },
];

export const projects = [
    {
        id: 8,
        title: "Book Social Network",
        date: "2025",
        description:
            "Book Social Network is a full-stack web application designed for book enthusiasts to manage their personal book collections and engage with a community of readers. The platform allows users to register securely, validate their accounts via email, and manage their books by creating, updating, archiving, and sharing them with others. It features a robust borrowing system that ensures availability checks before lending books, along with a return process that includes admin approval for enhanced accountability. The application follows RESTful API best practices and implements JWT-based authentication for secure access. Additionally, it includes comprehensive API documentation through Swagger UI and OpenAPI integration, ensuring transparency and ease of interaction between frontend and backend services.",
        image: BSN,
        tags: [
            "Spring Boot",
            "Spring Security",
            "Angular",
            "PostgreSQL",
            "JWT",
            "Docker",
            "OpenAPI and Swagger UI Documentation",
        ],
        github: "https://github.com/Thuvaraki/Book-Social-Network.git",
    },
    {
        id: 7,
        title: "QuickAi",
        date: "2025",
        description:
            "Quick.ai is an AI-Powered Content Creation Platform , that enables users to generate articles, blog titles, and images, as well as edit images by removing backgrounds or objects. Leveraged Gemini API for text generation, ClipDrop API for image generation, and Cloudinary for image editing. Implemented features for user engagement, including a community section to view, like, and dislike published creations. Built with React, Tailwind CSS, Node.js, Express, and PostgreSQL (Neon), with Clerk handling authentication, profile management, and billing. Designed an intuitive UI including a homepage, dashboard, and user profile, providing a seamless and secure content creation experience.",
        image: QuickAi,
        tags: [
            "React Js",
            "Node.js",
            "Express.js",
            "Postgress (Neon) ",
            "TailwindCSS",
            "Clerk",
        ],
        github: "https://github.com/Thuvaraki/Quick.ai.git",
    },
    {
        id: 6,
        title: "LuxeStay",
        date: "2024",
        description:
            "This is a comprehensive hotel management application with a Spring Boot backend and a React frontend. It allows users to browse, search, and book rooms, view their bookings and profiles. Admins can manage room listings and bookings. The application uses JWT for secure authentication and MySQL as the database.",
        image: LuxeStay,
        tags: ["React Js", "SpringBoot", "BootStrap", "MySQL", "JWT"],
        github: "https://github.com/Thuvaraki/LuxeStay",
    },
    {
        id: 5,
        title: "Insurance Management System",
        date: "2024",
        description:
            "This project is a backend service for an Insurance Management System built using Spring Boot. It provides functionalities to manage user authentication, insurance policy creation, enrollment, claims processing, and related operations. The project utilizes JWT for secure user authentication and role-based access control to ensure data security and restricted access.",
        image: Insurance,
        tags: ["SpringBoot", "MySQL", "JWT"],
        github: "https://github.com/Thuvaraki/Insurance-Management-Project",
    },
    {
        id: 4,
        title: "Goway",
        date: "2024",
        description:
            "Goway is a comprehensive bus ticket booking web application. It streamlines the booking process for travelers and offers efficient management tools for administrators. Users can search for buses by route and date, sort results by arrival/departure time, seat availability, or price, and apply filters based on price range, bus type, time category, and bus partners. They can view and select seats from a visual layout, complete bookings by entering passenger details, receive a booking confirmation code, and are reminded to pay while traveling. Users can also cancel bookings using the confirmation code. On the admin side, the system allows managing travel companies, adding and deleting routes and buses, and scheduling journeys with all relevant details.",
        image: Goway,
        tags: [
            "React Js",
            "Node Js",
            "Express JS",
            "SpringBoot",
            "Tailwind CSS",
            "MongoDB",
        ],
        github: "https://github.com/Thuvaraki/Goway",
    },
    {
        id: 3,
        title: "FoodieGo",
        date: "2024",
        description:
            "A food ordering web app, built with the MERN stack and styled with CSS, integrates Stripe for secure payments. Users can browse the menu and food items but must register to add items to their cart, place orders, and track order status. The admin panel allows administrators to add food items, view all foods, manage orders, and update order statuses.",
        image: FoodieGo,
        tags: ["React Js", "Node Js", "Express JS", "CSS", "JWT", "MongoDB"],
        github: "https://github.com/Thuvaraki/FoodieGo",
    },
    {
        id: 2,
        title: "Movie-App",
        date: "2024",
        description:
            "A movie app developed with Next.js, inspired by IMDb. Users can explore trending and top-rated movies, view detailed information about individual films, and utilize a powerful search functionality.",
        image: Movie,
        tags: ["Next Js", "CSS"],
        github: "https://github.com/Thuvaraki/Movie-app/tree/main/src/app",
    },
    {
        id: 1,
        title: "BiteBliss",
        date: "2023",
        description:
            "This group project is a full stack web application designed to provide users with a seamless platform to order food online. Built with the MERN stack, the application includes core features such as user authentication, product browsing and search functionality, category-based product filtering, and cart management. Users can place orders, proceed to checkout (cash on delivery only), and view their order history through a personalized profile section. The system ensures a smooth and intuitive user experience from product discovery to order completion.",
        image: BiteBliss,
        tags: ["React Js", "SpringBoot", "JWT", "MySQL", "CSS"],
        github: "https://github.com/Thuvaraki/BiteBliss-Fullstack-Web-Application",
        member: [
            {
                name: "Dharsi",
                img: "https://img.freepik.com/premium-vector/software-developer-vector-illustration-communication-technology-cyber-security_1249867-5464.jpg?semt=ais_hybrid&w=740",
                github: "https://github.com/DharshiBalasubramaniyam",
            },
            {
                name: "Pooja",
                img: "https://png.pngtree.com/png-vector/20240506/ourmid/pngtree-cute-cartoon-girl-doing-office-work-on-transparent-background-png-image_12375933.png",
                github: "https://github.com/pooja180801",
            },
            {
                name: "Jawuthamy",
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyenR6DDhU2kf3qxMjo2-8KCjrz1B3N0ZM8g&s",
                github: "https://github.com/jawuthamythiruchelvam",
            },
        ],
    },
    {
        id: 0,
        title: "PinkPearl",
        date: "2023",
        description:
            "This group project is a full stack e-commerce website for ladies' fashion developed using PHP, HTML, CSS, and JavaScript. Users can register, log in, search and browse products, manage their wishlist and cart, place orders, contact support, view order history and status, and update their profile and password. The admin panel provides a dashboard with features to manage products and categories, handle user accounts, update order statuses, manage customer messages, and maintain admin profile settings. The system offers a complete shopping and management experience.",
        image: PinkPearl,
        tags: ["HTML", "CSS", "JavaScript", "PHP"],
        github: "https://github.com/Thuvaraki/Ladies-fashion-full-stack-website",
        member: [
            {
                name: "Dharsi",
                img: "https://img.freepik.com/premium-vector/software-developer-vector-illustration-communication-technology-cyber-security_1249867-5464.jpg?semt=ais_hybrid&w=740",
                github: "https://github.com/DharshiBalasubramaniyam",
            },
            {
                name: "Pooja",
                img: "https://png.pngtree.com/png-vector/20240506/ourmid/pngtree-cute-cartoon-girl-doing-office-work-on-transparent-background-png-image_12375933.png",
                github: "https://github.com/pooja180801",
            },
            {
                name: "Jawuthamy",
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyenR6DDhU2kf3qxMjo2-8KCjrz1B3N0ZM8g&s",
                github: "https://github.com/jawuthamythiruchelvam",
            },
            {
                name: "Sageerthan",
                img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4k1TkdsbmVejP1ewv8_mQPZnmrw3SGO6jyw&s",
                github: "https://github.com/sageerthan",
            },
        ],
    },
];

export const achievements = [
    {
        id: 0,
        title: "JuniorHack 5.0 - Winner (Group)",
        description:
            "Intra-university hackathon, Organized by Software Engineering Students’ Association, University of Kelaniya",
    },
    {
        id: 1,
        title: "Py Hack 2.0 - Participant (Group)",
        description:
            "Inter-university hackathon, Organized by IEEE WIE Affinity Group of IIT",
    },
    {
        id: 2,
        title: "Dean's List",
        description:
            "Included in Dean's List for outstanding achievement in Level 1, 3, and 4",
    },
];
